var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.title")) + " ")]), _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.subtitle")) + " ")]), _vm.value.status === _vm.RequestStatusEnum.REPLIED ? _c('v-card-text', [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "success"
    }
  }, [_vm._v(" mdi-bookmark-check-outline ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.replied")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.value.number) + ", " + _vm._s(_vm.value.total) + " € ")])], 1)], 1)], 1) : _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "info",
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.makeOffer")) + " ")])], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "title": _vm.$t('repairEstimateRequest.response.makeOffer'),
      "subtitle": _vm.$t('repairEstimateRequest.response.makeOfferSubtitle'),
      "loading": _vm.loading,
      "rightLoading": _vm.loading,
      "rightDisabled": !_vm.isValid,
      "leftText": _vm.$t('close'),
      "rightText": _vm.$t('repairEstimateRequest.response.confirmOffer')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.close,
      "rightClick": _vm.confirmRepairEstimateResponse
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('file-input', {
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.documentId'),
      "hint": _vm.$t('objects.repairEstimateRequest.documentIdHint'),
      "persistentHint": true,
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "outlined": true
    },
    model: {
      value: _vm.file,
      callback: function callback($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.number'),
      "hint": _vm.$t('objects.repairEstimateRequest.numberHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.valueCopy.number,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "number", $$v);
      },
      expression: "valueCopy.number"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.total'),
      "hint": _vm.$t('objects.repairEstimateRequest.totalHint'),
      "persistent-hint": true,
      "type": "number",
      "min": 0,
      "append-icon": "€",
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.valueCopy.total,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "total", _vm._n($$v));
      },
      expression: "valueCopy.total"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.date'),
      "hint": _vm.$t('objects.repairEstimateRequest.dateHint'),
      "persistent-hint": true,
      "type": "date",
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.dateFormable,
      callback: function callback($$v) {
        _vm.dateFormable = $$v;
      },
      expression: "dateFormable"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }